import type { Spritesheet, Texture } from "pixi.js";

/**
 * Per-symbol WIN-animation frames as ordered symbols-atlas frame names, base first and the
 * alt / switched-to frame last (e.g. `H1: ["H1", "H1-2"]`). The overlay-fade win effect shows the
 * LAST frame as the win look, for a build without Spine symbols. A symbol not listed, a name
 * the atlas lacks, or an entry left with fewer than two frames gets the pulse only.
 */
export const SYMBOL_WIN_FRAME_SOURCES: Record<string, readonly string[]> = {
  H1: ["H1", "H1-2"],
  H2: ["H2", "H2-2"],
  H3: ["H3", "H3-2"],
  H4: ["H4", "H4-2"],
};

/** Resolves `SYMBOL_WIN_FRAME_SOURCES` against the loaded symbols atlas; unresolvable entries are dropped. */
export function resolveSymbolWinFrames(atlas: Spritesheet): Map<string, Texture[]> {
  const map = new Map<string, Texture[]>();
  for (const [symbolId, names] of Object.entries(SYMBOL_WIN_FRAME_SOURCES)) {
    const frames = names.map((name) => atlas.textures[name]).filter((f): f is Texture => !!f);
    if (frames.length >= 2) map.set(symbolId, frames);
  }
  return map;
}
